module.exports = __webpack_public_path__ + "img/Right-header-about-page.60fa87c.svg";